import {
    PROJECTS_CRUD_SET_LIST,
    PROJECTS_CRUD_RESET,
    LEGACY_COMPONENT_USER_DIALOG,
    GLOBAL_PROJECT_TYPE_CHAMBER,
    SHOW_MANIFOLD_ENTRY,
    CLOSE_MANIFOLD_ENTRY, SUB_PROJECTS_CRUD_RESTORE_STATE, FLOATING_TOOL_TEE_CLOSE,
} from "../lib/types";
import {
    setChamberType,
} from "../actions/apptoolbar-actions";

export const setSubProjectsList = projects => dispatch => {
    dispatch({
        type: PROJECTS_CRUD_SET_LIST,
        payload: projects,
    });
};

export const resetSubProjectsList = () => dispatch => {
    dispatch({
        type: PROJECTS_CRUD_RESET,
    });
};

/**
 * Prepares the state that will persis data on server
 * @returns {*}}
 */
export const getSubProjectStateToPersist = () => (dispatch, getState) => {
    /* extracting all necessary state */
    let {
        globals,
        viewport,
        chamberbed,
        stonebed,
        calculations,
        upperManifolds,
        lowerManifolds,
        mainManifolds,

        pipeGlobals,
        pipeBed,
    } = getState();

    return {
        globals,
        viewport,
        chamberbed,
        stonebed,
        calculations,
        upperManifolds,
        lowerManifolds,
        mainManifolds,

        pipeGlobals,
        pipeBed,
    };
};

/**
 * NOTE: This function invokes set state twice to prevent
 * inconsistencies of state when componentDidUpdate are
 * executed in other components. Two pases will make sure
 * the state is correct.
 *
 * @param {Object} state Unserialized minicad state.
 */
export const restoreSubProjectPersistedState = (state) => (dispatch, getState) => {
    // if (state.chamberbed.chamberRows && state.chamberbed.chamberRows[4] && state.chamberbed.chamberRows[4]._chambers[0])
    //     console.log('%c  >>>>>>>>', 'background: #222; color: #bada55', state.chamberbed.chamberRows[4]._chambers[0]._isIsolatorArray)
    const previousState = getState();

    // Fix chamber type before sending it along
    const {chambers, endcaps} = previousState.apptoolbar;
    let {chamberType, chamberEndCapType} = state.globals;

    const chamberbed = state.chamberbed;
    const {totalStorageProvided} = state.calculations;

    chamberType = chamberType || previousState.globals.chamberType;
    chamberEndCapType = chamberEndCapType || previousState.globals.chamberEndCapType;

    let newChamberType = chambers.find(chamber => chamber.id === chamberType.id);
    let newChamberEndCapType = endcaps.find(endCap => endCap.id === chamberEndCapType.id);

    if (state.globals.projectType === GLOBAL_PROJECT_TYPE_CHAMBER
        && newChamberType.id === "MC-4500"
        && chamberEndCapType.installedLength < newChamberEndCapType.installedLength) {
        if (!previousState.apptoolbar.showLegacyComponentDialog) {
            dispatch({
                type: LEGACY_COMPONENT_USER_DIALOG,
                payload: {
                    showDialog: true,
                },
            });
        }
        setChamberType(newChamberType, newChamberEndCapType);
    }
    if (previousState.manifoldEntry && previousState.manifoldEntry.showManifoldEntryDialog) {
        dispatch({
            type: SHOW_MANIFOLD_ENTRY,
            payload: {
                accessory: {},
                manifoldId: null,
                showManifoldEntryDialog: false,
            },
        });
        dispatch({
            type: CLOSE_MANIFOLD_ENTRY,
        });
        dispatch({
            type: FLOATING_TOOL_TEE_CLOSE,
        });
    }
    dispatch({
        type: SUB_PROJECTS_CRUD_RESTORE_STATE,
        payload: {
            ...state,
            globals: {
                ...state.globals,
                chamberType: newChamberType,
                chamberEndCapType: newChamberEndCapType,
            },
            chamberbed,
            totalStorageProvided,
        },
    });
};



// WEBPACK FOOTER //
// ./src/actions/sub-project-crud-actions.js